import { render, staticRenderFns } from "./yrityslainavertailut.vue?vue&type=template&id=2fccf1e6&"
import script from "./yrityslainavertailut.vue?vue&type=script&lang=js&"
export * from "./yrityslainavertailut.vue?vue&type=script&lang=js&"
import style0 from "./yrityslainavertailut.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports